export const ALERT_TITLE = {
  info: 'Информация!',
  success: 'Успешно!',
  warning: 'Предупреждение!',
  error: 'Ошибка!'
}
